import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad43ab4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "container"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "GALLERY NAME", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, "GALLERY INFO", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "NAME", -1))
const _hoisted_7 = { class: "input-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "website" }, "WEBSITE", -1))
const _hoisted_9 = { class: "input-wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "DESCRIPTION", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Update"
}, null, -1))
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.loader)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.role === 'gallery')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_ctx.name), 1)
            ]),
            _createVNode(_component_v_divider),
            _hoisted_4,
            _createVNode(_component_v_divider),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.name), 1)
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleUpdateInfo(_ctx.link, _ctx.description)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "website",
                    placeholder: "WEBSITE",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.link) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.link]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("textarea", {
                    id: "description",
                    placeholder: "DESCRIPTION",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.description]
                  ])
                ]),
                _hoisted_11,
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)))
                }, " RESET YOUR PASSWORD ")
              ], 32)
            ])
          ]))
        : (_ctx.role === 'artist' || _ctx.role === 'private_seller')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)))
              }, "RESET YOUR PASSWORD")
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}